export function hideImages() {
  document.querySelectorAll("img").forEach((img) => {
    img.style.visibility = "hidden";
  });
}

export function unhideImages() {
  document.querySelectorAll("img").forEach((img) => {
    img.style.visibility = "visible";
  });
}
